var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"viz"}},[_c('div',{attrs:{"id":"labels-container"}}),(_vm.loaded)?_c('RectArea',{attrs:{"scene":_vm.scene,"camera":_vm.camera}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }